import { http } from '../http'
import { mockGetProfile, setMockOnboardingComplete } from '@/mocks/authMock'

export async function getProfile() {
	// Пока бэк не отдаёт email/plan/onboarding_complete — под VITE_AUTH_MOCK берём их из мока
	if (import.meta.env.VITE_AUTH_MOCK) {
		return mockGetProfile()
	}
	return http.get(`/user`).then((response) => response.data)
}

export async function completeOnboarding() {
	// Пока бэк не поднял ручку — под VITE_AUTH_MOCK переключаем локальный флаг,
	// иначе экран онбординга показывался бы после каждого входа.
	if (import.meta.env.VITE_AUTH_MOCK) {
		setMockOnboardingComplete(true)
		console.warn('🎯 [MOCK] POST /user/onboarding-complete')
		return { data: { onboarding_completed: true } }
	}
	return http.post('/user/onboarding-complete').then((response) => response.data)
}

export async function getSubsStatus() {
	return http.get('/users/subs-status')
}
